// extracted by mini-css-extract-plugin
export var backdropBlur = "_by-0";
export var contentCard = "_by-5";
export var frame = "_by-2";
export var image = "_by-4";
export var imagePane = "_by-3";
export var modal = "_by-1";